import { NonNullableRepository } from 'ddd-base';
import { createStorageInstance } from '@/infra/repository/StorageManager';
import { AuthParams, AuthParamsConverter, AuthParamsJSON, createAuthParams } from '@/models/domain/AuthParams';

export class AuthParamsRepository extends NonNullableRepository<AuthParams> {
    private storage: LocalForage;

    constructor(initialEntity: AuthParams) {
        super(initialEntity);
        this.storage = createStorageInstance({
            name: 'AuthParamsRepository',
        });
    }

    /**
     * findを使用する前に呼ぶ必要がある
     */
    async ready(): Promise<AuthParams | null> {
        if (this.map.size > 0) {
            return Promise.resolve(null);
        }
        await this.storage.ready();
        const values: AuthParamsJSON[] = [];
        await this.storage.iterate<AuthParamsJSON, void>((value) => {
            values.push(value);
        });
        if (values.length === 0) {
            return null;
        }
        const entities = values.map((json) => {
            return AuthParamsConverter.fromJSON(json);
        });
        entities.forEach((param) => {
            this.map.set(param.id.toValue(), param);
        });
        await this.save(entities[0]);
        return entities[0];
    }

    save(entity: AuthParams) {
        super.save(entity);
        return this.storage.setItem(entity.id.toValue(), AuthParamsConverter.toJSON(entity));
    }

    async clear() {
        super.clear();
        await this.storage.clear();
    }
}

export const authParamsRepository = new AuthParamsRepository(createAuthParams());
